/* Using MaterialUI hook here, to be extracted if Mui will ever be removed */
export { useControlled } from '@material-ui/core';
//# sourceMappingURL=useControlled.js.map